var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultHomepageImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 410,
    height: 517.171,
    viewBox: "0 0 410 517.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-hp-image"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1609",
    "data-name": "Rectangle 1609",
    width: 410,
    height: 517.171,
    rx: 29,
    transform: "translate(1105 170.78)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-hp-image-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FOND_FIXE",
    "data-name": "FOND FIXE",
    d: "M0,0H575.613V848.606H0Z",
    transform: "translate(673.813 -27.569)",
    fill: "#3b3b3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-hp-image",
    x1: 0.507,
    y1: -0.001,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe6c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-hp-image-2",
    x1: 0.519,
    y1: 0.142,
    x2: 0.543,
    y2: 0.948,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#fff6e8",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff1dc",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#ffedd2",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#ffeacb",
    stopOpacity: 0.208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#ffe7c5",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#ffe6c2",
    stopOpacity: 0.024
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe6c1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-hp-image-3",
    x1: 0.5,
    y1: 0.022,
    x2: 0.5,
    y2: 0.705,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dce7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#b8dcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbe298"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-hp-image-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeaa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2cc76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-hp-image-5",
    x1: 0.424,
    y1: 0.676,
    x2: 0.697,
    y2: 0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-hp-image-6",
    x1: 0.5,
    x2: 0.5,
    y2: 0.84,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcdc96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb74a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-hp-image-7",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb74a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5d382"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-hp-image-8",
    x1: 0.5,
    y1: 0.089,
    x2: 0.491,
    y2: 2.079,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffdfa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6210",
    "data-name": "Group 6210",
    transform: "translate(-1105 -170.78)",
    clipPath: "url(#clip-path-hp-image)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FOND",
    transform: "translate(328.246 182.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_57",
    "data-name": "Mask Group 57",
    transform: "translate(0)",
    clipPath: "url(#clip-path-hp-image-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1606",
    "data-name": "Rectangle 1606",
    width: 1312.754,
    height: 706.974,
    transform: "translate(78.227 16.073)",
    fill: "url(#linear-gradient-hp-image)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11229",
    "data-name": "Path 11229",
    d: "M1232.91,64.629V204.768q-32.941.488-66.387,1.014c-138.543,2.125-282.147,4.173-417.566,1.684-136.827-2.517-276.734-3.225-401.218-28.08,19.433-10.939,59.9-13.245,85.139-4.862,4.4-5.761,25.457-8.508,36.044-4.546,6.909-12.614,33.161-24.3,62.186-27.276s61.48,1.732,80.6,11.685c13.311-5.7,37.012-7.274,53.538-3.484,12.1-8.814,37.232-12.556,55.516-6.049,6.384-13.925,30.567-26.137,61.638-30.491s67.291-.852,91.186,8.824c10.168-2.929,28.166-1.627,37.474,1.79,22.469-14.078,76.337-19.466,111-11.312,4.907-11.274,30.037-21.122,54.2-25.706,24.184-4.594,53.494-3.637,75.829,2.46,5.589-9.149,28.276-16.164,47.025-20.969A168.616,168.616,0,0,1,1232.91,64.629Z",
    transform: "translate(157.398 419.627)",
    fill: "url(#linear-gradient-hp-image-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6209",
    "data-name": "Group 6209",
    transform: "translate(-115.331 -27.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FOND-2",
    "data-name": "FOND",
    d: "M1615.009,870.7H0V0H1615.009Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-hp-image-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "FOND_DUNE",
    "data-name": "FOND DUNE",
    transform: "translate(93.914 435.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6206",
    "data-name": "Group 6206",
    transform: "translate(547.733 6.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11230",
    "data-name": "Path 11230",
    d: "M1180.149,330.811v96.451s-1025.968-39.407-882.11-54.584c279.209-29.464,444.279-76.059,578.392-76.853a470.088,470.088,0,0,1,76.266,5.33C1136.944,330.121,1180.149,330.811,1180.149,330.811Z",
    transform: "translate(-284.211 -295.813)",
    fill: "url(#linear-gradient-hp-image-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11231",
    "data-name": "Path 11231",
    d: "M895.818,330.811v21.972c-30.255,1.569-33.626,1.97-92.452-.166C636.484,346.562,599.09,306.362,592.1,295.825a470.088,470.088,0,0,1,76.266,5.33C852.613,330.121,895.818,330.811,895.818,330.811Z",
    transform: "translate(0.12 -295.813)",
    fill: "url(#linear-gradient-hp-image-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6208",
    "data-name": "Group 6208",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6207",
    "data-name": "Group 6207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11232",
    "data-name": "Path 11232",
    d: "M1443.672,378.132V479.986H0V318.728s64.163-18.068,108.647-28.4c3.107-.722,7.231-1.982,11.2-1.868,78.961,2.259,266.181,77.574,713.914,99.78,199.617,9.9,449.829,5.606,449.829,5.606Z",
    transform: "translate(0 -288.45)",
    fill: "url(#linear-gradient-hp-image-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11233",
    "data-name": "Path 11233",
    d: "M1226.923,395.962c-91.36,8.7-559.689,48.285-869.379,7.293C42.423,361.537,58.121,300.742,63.065,290.7c78.975,2.259,266.352,75.924,714.163,98.13C976.881,398.726,1121.709,397.3,1226.923,395.962Z",
    transform: "translate(56.576 -290.691)",
    fill: "url(#linear-gradient-hp-image-7)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "FOND-3",
    "data-name": "FOND",
    d: "M1615.009,244.587H0V0H1615.009Z",
    transform: "translate(0 626.116)",
    fill: "url(#linear-gradient-hp-image-8)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultHomepageImage);
export default __webpack_public_path__ + "static/media/default-homepage-image.154ca0ac.svg";
export { ForwardRef as ReactComponent };